export { default } from './CGMSubHeader';
